import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import Select from "react-select";
import Loader from "../../../../comman/Loader";
import {baseUrl, feedProductType} from "../../../../comman/config";
import { useNavigate, Link } from 'react-router-dom';

export default function Form({detail}) {
    const today = new Date().toISOString().split("T")[0];
    const [formData, setFormData] = useState({
        date : today,
        company_id : '',
        product_type: '',
        product_name:'',
        product_quantity: '',
        product_price: ''
    });
    const [validationErrors, setValidationErrors] = useState({
        date: false,
        company_id: false,
        product_type : false,
        product_name : false,
        product_quantity : false,
        product_price : false
    });
    const [popupOpen , setPopupOpen] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [productList, setProductList] = useState([]);
    const formRef = useRef(null);
    
    
    const navigate = useNavigate();

    useEffect(() => {
        getFeedCompanyList();
        getProductList();
    }, [])
    useEffect(() => {
        
        if(detail){
            const companyObject = companyList.find((item) => item.id == detail[0].company_id);
            const company = companyObject ? {value : companyObject.id, label : companyObject.name} : {value : "", label : ""};

            const productObj = productList.find((val) => val.id == detail[0].product_name);
            const product = productObj ? {value : productObj.id, label : productObj.name} : {value : "", label : ""};
            setFormData({
                date: detail[0].date || today,
                company_id: company,
                product_type : feedProductType.find((val) => val.value == detail[0].product_type) || '',
                product_name : product || '',
                product_quantity : detail[0].product_quantity || '',
                product_price : detail[0].product_price,
                db_id: detail[0]?.id ?? 0
            });
        }
    }, [detail, companyList, productList]);
  

    const getFeedCompanyList = async () => {
        setPopupOpen(true);
        
        const condition = `(product_type =  2 OR product_type =  3) AND company_type = 1  AND status = 1`;
        const response = await axios.get(`${baseUrl}/admin/profile/company/company_list?condition=${condition}`);
        setCompanyList(response.data.data);
        setPopupOpen(false);
    }

    const getProductList = async ()=> {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/profile/product/list_all`);
        setPopupOpen(false);
        setProductList(response.data.data);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            date: formData.date === '',
            company_id : !formData.company_id.value,
            product_type : !formData.product_type.value,
            product_name : !formData.product_name.value,
            product_quantity : formData.product_quantity === '',
            product_price : formData.product_price === '',
            
        };
        setValidationErrors(newValidationErrors);
        const hasErrors = Object.values(newValidationErrors).some((error) => error);
        if (hasErrors) {
            
            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            if (firstInvalidInput) {
              // Scroll to the first invalid input element
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }else {
            let url;
            try {
                setPopupOpen(true);
                if(detail){
                    url = `admin/farm/feed/edit/${detail[0].id}`;
                }else{
                    url = "admin/farm/feed/add";
                }
                console.log(url);
                await axios.post(`${baseUrl}/${url}`,{
                    formData: formData,
                });
                setPopupOpen(false);
                navigate("/admin/farm/feed");
            } catch (error) {

                setPopupOpen(false);
                console.log(error);
                
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
    
            }));
      
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

    const handleSelectChange = (data, option) => {
        if(option.name == "product_type"){
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
                "company_id" : ""
            }));
        }else{
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
            }));
        }
        
        
        
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [option.name]: false,
        }));
      };
    

  return (
 
 <form ref={formRef}>
    {popupOpen && (
                     <Loader /> 
                ) }
                <div className="space-y-12">
                    <div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="date" className="block text-sm font-medium leading-6 text-gray-900">Date</label>
                                <div className="mt-2">
                                <input
                                    type="date"
                                    name="date"
                                    id="date"
                                    value={formData.date}
                                    onChange={handleInputChange}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.date ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.date && <div className="text-red-500">Please enter a date.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="product_type" className="block text-sm font-medium leading-6 text-gray-900">Product Type</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.product_type}
                                        name="product_type"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={feedProductType.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.product_type && <div className="text-red-500">Please select a product type.</div>}
                            </div>
                        </div>
                       
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                        <div className="sm:col-span-2">
                                <label htmlFor="company_id" className="block text-sm font-medium leading-6 text-gray-900">Company</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.company_id}
                                        name="company_id"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={companyList.filter((val) => val.product_type == (formData.product_type.value == 1 ? 2 : 3)).map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.company_id && <div className="text-red-500">Please select a company.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="product_name" className="block text-sm font-medium leading-6 text-gray-900">Product Name</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.product_name}
                                        name="product_name"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={productList.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.product_name && <div className="text-red-500">Please enter product name.</div>}
                            </div>
                            
                            
                         
                        </div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                        <div className="sm:col-span-2">
                                <label htmlFor="product_quantity" className="block text-sm font-medium leading-6 text-gray-900">Product Quantity</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="product_quantity"
                                      name="product_quantity"
                                      type="number"
                                      step="0.01"
                                      placeholder='Quantity'
                                      value={formData.product_quantity}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.product_quantity ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.product_quantity && <div className="text-red-500">Please enter quantity.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="product_price" className="block text-sm font-medium leading-6 text-gray-900">Product Price</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="product_price"
                                      name="product_price"
                                      type="number"
                                      step="0.01"
                                      placeholder='Price'
                                      value={formData.product_price}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.product_price ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.product_price && <div className="text-red-500">Please enter price.</div>}
                            </div>
                            
                         
                        </div>

                        
                    </div>
                </div>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <Link to="/admin/farm/feed">
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
                    </Link>
                    <button
                    onClick={handleSubmit}
                      type="submit"
                      className="rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save
                    </button>
                </div>
            </form>
            )
        }